import { render, staticRenderFns } from "./WebIframeConfig.vue?vue&type=template&id=6cf1d702&scoped=true"
import script from "./WebIframeConfig.vue?vue&type=script&lang=js"
export * from "./WebIframeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf1d702",
  null
  
)

export default component.exports